<template>
    <ModalFormCard class="modal-default">
        <template #title>Edit contact options</template>

        <Communications
            ref="comm"
            :owner="editingModel"
            :communications="editingModel.communications"
            :modelId="editingModel.id"
            modelType="contact"
            @saved="
                () => {
                    $event.$emit('modal-close')
                    $event.$emit('modal-form-completed')
                }
            "
        />

        <div class="grid grid-cols-4 pt-6">
            <ButtonSaving
                :disabled="$refs.comm != null && $refs.comm.saving"
                class="button-black h-12 col-span-2"
                type="button"
                @click="$refs.comm.save()"
            >
                Save changes
            </ButtonSaving>
        </div>
    </ModalFormCard>
</template>

<script>
import Communications from '~/components/customer/input/communications.vue'
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    components: {
        Communications,
    },
}
</script>
